import Question from "./question.js"
import GriddedQuestionComponent from "../components/questions/gridded-question.jsx"
import GriddedPreviewComponent from "../components/previews/gridded-preview.jsx";
class GriddedQuestion extends Question {
  component(mode) {
    if(mode == "preview") {
      return GriddedPreviewComponent;
    }
    return GriddedQuestionComponent;
  }
}

export default GriddedQuestion;